// extracted by css-extract-rspack-plugin
var _1 = "-FWebikhGvTiDwKBBFcqlg--";
var _2 = "dB95-liwy18AizVALmfrrg--";
export { _1 as "info", _2 as "infoIcon" }
